import { engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { LayoutSwitchElement } from "./LayoutSwitchElement";
import { SwitchStyle } from "../Components/Elements/Styles/SwitchStyle";
import { StyleManager } from "../Components/Managers/StyleManager";

@engineComponent(ComponentTypes.DisplayObject)
export class LayoutSwitchElementExtended extends LayoutSwitchElement {
    protected portraitLeftHandStyle: SwitchStyle;

    protected leftHandStyle: SwitchStyle;

    protected isLeftHandMode: boolean;

    constructor() {
        super();

        this.portraitLeftHandStyle = null;
        this.leftHandStyle = null;
        this.isLeftHandMode = false;
    }

    createByNode(node: Element) {
        super.createByNode(node);

        if (node.hasAttribute("PortraitLeftHandStyle")) {
            this.portraitLeftHandStyle = <SwitchStyle>StyleManager.Styles[node.getAttribute("PortraitLeftHandStyle")];
        }

        if (node.hasAttribute("LeftHandStyle")) {
            this.leftHandStyle = <SwitchStyle>StyleManager.Styles[node.getAttribute("LeftHandStyle")];
        }
    }

    onLayoutChange(isPortrait: boolean): void {
        let style = this.getStyle(isPortrait);

        //update layout only if orientation was changed
        if (style == this.style) {
            return;
        }

        if (style != null) {
            let caseType = this.case;
            this.case = "";
            this.style = style;
            this.storeData(caseType);
            this.goToCase(caseType);
            this.restoreData(caseType);

            this.inPortraitMode = isPortrait;
            this.emit(LayoutSwitchElement.LayoutChange, this.inPortraitMode);
        }
    }

    onLeftHandLayoutChange(isLeftHand: boolean): void {
        this.isLeftHandMode = isLeftHand;
        let style = this.getStyle(this.inPortraitMode);

        //update layout only if orientation was changed
        if (style == this.style) {
            return;
        }

        if (style != null) {
            let caseType = this.case;
            this.case = "";
            this.style = style;
            this.storeData(caseType);
            this.goToCase(caseType);
            this.restoreData(caseType);

            this.emit(LayoutSwitchElement.LayoutChange, this.inPortraitMode);
        }
    }

    protected getStyle(isPortrait: boolean): SwitchStyle {
        let style = this.baseStyle;

        if (isPortrait) {
            style = this.portraitStyle;
            if (this.isLeftHandMode && this.portraitLeftHandStyle) {
                style = this.portraitLeftHandStyle;
            }
        } else {
            if (this.isLeftHandMode && this.leftHandStyle) {
                style = this.leftHandStyle;
            }
        }

        return style;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/LayoutSwitchElementExtended.ts
 **/